import { Box } from "@mui/material";

import { detectIsMac, keycapTokens } from "~/keyboard/bindings";

interface KeycapProps {
	binding: string;
	isMac?: boolean;
}

const keycapSx = {
	alignItems: "center",
	backgroundColor: "action.hover",
	border: 1,
	borderColor: "divider",
	borderRadius: 0.75,
	color: "text.primary",
	display: "inline-flex",
	fontFamily: "'JetBrains Mono', monospace",
	fontSize: "0.72rem",
	justifyContent: "center",
	lineHeight: 1,
	minWidth: 20,
	px: 0.75,
	py: 0.375
} as const;

const Keycap = ({ binding, isMac }: KeycapProps) => {
	const tokens = keycapTokens(binding, isMac ?? detectIsMac());
	return (
		<Box sx={{ alignItems: "center", display: "inline-flex", gap: 0.375 }}>
			{tokens.map((token, index) => (
				<Box component="kbd" key={`${token}-${index}`} sx={keycapSx}>
					{token}
				</Box>
			))}
		</Box>
	);
};

export default Keycap;
